<template>
  <div class="activities-table">
    <draggable :list='activities' :options="{ handle: '.activities-table__cell-handle', disabled: !moduleSaved }">
      <div v-for='(activity, i) in activities' class="activities-table__row" :key='activity.id'>
        <div class="activities-table__cell activities-table__cell-handle" @mousedown='showReorderWarning'></div>
        <div class="activities-table__cell">
          {{ title(activity) }}
        </div>
        <div class="activities-table__cell">
          {{ criteriaLine(activity) }}
        </div>
        <div class="activities-table__cell activities-table__cell-actions">
          <a @click="$emit('edit', i)" class="action-btn edit kd-ibtn" href="javascript:;">
            <i class="kf kf-pencil"></i>
          </a>
          <a @click="$emit('delete', i)" class="action-btn delete kd-ibtn kd-ibtn--delete" href="javascript:;">
            <i class="kf kf-trashcan"></i>
          </a>
        </div>
      </div>
    </draggable>
    <div class="activities-table__row">
      <div class="activities-table__cell">
        <a href="javascript:;"
          class='add-activities-btn'
          @click='$emit("add")'>
          <i class="kf kf-plus"></i>
          {{Kadenze.I18n.t('learning_module.add_activity.heading')}}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable';

export default {
  props: {
    activities: {
      type: Array,
      default: () => []
    },
    modulables: {
      type: Object
    },
    moduleSaved: false,
  },
  components: {
    draggable
  },
  data() {
    return {
      showAddActivity: false
    }
  },
  methods: {
    title(activity) {
      return _.find(this.modulables[activity.learning_modulable_type.toLowerCase()], (m) => {
        return m.id == activity.learning_modulable_id
      }).title
    },
    criteriaLine(activity) {
      if (activity.required) {
        return `Required (${activity.criteria.type})`
      }
      return '';
    },
    showReorderWarning() {
      if ( this.moduleSaved ) {
        return;
      }
      new Kadenze.Notice.info({message: 'Please save Module before reordering activities'})
    }
  }
}
</script>
